import { getInitials } from "./downloadFromS3"

export const isLegacy = (
  date: Date,
  tagData: Record<string, string | string[]>,
) => {
  // Only consider something legacy if tagData["Source"] is not "Legacy"
  // check the Source key exists and is set to "Legacy"
  if (tagData && tagData["Source"] && tagData["Source"] === "Legacy") {
    return false
  }

  // legacy date sept 4 2025
  const legacyThreshold = new Date("2025-09-04")
  return date < legacyThreshold
}
export const createLegacyCustomName = (
  id: string,
  tagData: Record<string, string | string[]>,
  s3Filename: string,
  assetCategory: string | undefined,
) => {
  const fileExtension = s3Filename.split(".").pop() || ""

  const getTagValue = (key: string, joinWith = "_") => {
    const value = tagData[key]
    if (Array.isArray(value)) {
      return value.join(joinWith)
    }
    return value || "_"
  }

  if (!!Object.keys(tagData).length) {
    let nameStr = ""
    switch (assetCategory) {
      case "Game - Video":
      case "Ads - Video":
        nameStr += getInitials(getTagValue("Game"))
        nameStr += `_${getTagValue("Serial Num")}`
        nameStr += `_${getTagValue("Concept").replaceAll(" ", "_")}`
        nameStr += `_${getTagValue("Project Type")}`
        nameStr += `_${getTagValue("Project level")}`
        nameStr += `_${getTagValue("Duration")}`
        nameStr += `_${getTagValue("Dimension")}_`
        break

      case "Game - Image":
      case "Ads - Image":
        nameStr += getInitials(getTagValue("Game"))
        nameStr += `_${getTagValue("Project Type - image")}`
        nameStr += `_${getTagValue("Artist")}`
        nameStr += `_${getTagValue("Devices")}`
        nameStr += `_${getTagValue("Platform")}`
        nameStr += `_${getTagValue("Dimension")}`
        nameStr += `_${getTagValue("Serial Num")}_`
        break

      case "Other - Video":
      case "ASO - Video":
        nameStr += getTagValue("Project Name")
        nameStr += `_${getTagValue("Project Type")}`
        nameStr += `_${getTagValue("Artist")}`
        nameStr += `_${getTagValue("Version Number")}_`
        break

      case "Other - Image":
      case "ASO - Image":
        nameStr += `_${getTagValue("Project Name")}`
        nameStr += `_${getTagValue("Project Type - image")}`
        nameStr += `_${getTagValue("Artist")}`
        nameStr += `_${getTagValue("Version Number")}_`
        break

      default:
        nameStr += getInitials(getTagValue("Game"))
        nameStr += `_${getTagValue("Serial Num")}`
        nameStr += `_${getTagValue("Concept").replaceAll(" ", "_")}`
        nameStr += `_${getTagValue("Project Type - image")}`
        nameStr += `_${getTagValue("Project level")}`
        nameStr += `_${getTagValue("Duration")}`
        nameStr += `_${getTagValue("Dimension")}_`
        break
    }

    return `${nameStr}${id}.${fileExtension}`
  } else {
    return s3Filename
  }
}
